import React, { Component } from 'react';
import { ZiggeoPlayer } from 'react-ziggeo';
import styled from 'styled-components';
// import loginImage from 'src/assets/images/convo-login-illustration.svg';
// import UserLayout from '../components/UserLayout/UserLayoutEmail';
// import {
//     SITE_DESCRIPTION,
//     VIDEO_MAIL_PAGE_TITLE,
//     VIDEO_MAIL_PAGE_DESCRIPTION_PREFIX,
// } from '../config/seo.constants';
// import SEO from '../components/common/SEO';

const StyledVideoPlayerEmail = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    top: 30%;
    .container {
        display: block;
        height: 90vh;
    }
    .image-stack {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        position: relative;
    }
    .image-stack__item—top{
        Grid-column: 1
        Grid-row: 1; 
        Padding-top: 20% 
        z-index: 1; 
    }
    .image-stack__item—bottom {
        grid-column: 4
        grid-row: 1;
    }
`;

class VideoPlayer extends Component {
    API_KEY = `${process.env.REACT_APP_ZIGGEO_API_KEY}`;

    urlParams: any = new URLSearchParams(window.location.search);

    VIDEO_TOKEN: any = this.urlParams.get('videotoken').toString();

    componentDidMount() {}

    render() {
        return (
            // <UserLayout>
            //     <SEO
            //         title={VIDEO_MAIL_PAGE_TITLE}
            //         description={`${VIDEO_MAIL_PAGE_DESCRIPTION_PREFIX} - ${SITE_DESCRIPTION}`}
            //     />

            //     <div className="image-stack">
            //         <div
            //             className="image-stack__item image-stack__item—top"
            //             style={{ position: 'absolute', left: '40px', top: '50%' }}
            //         >
            //             <img src={loginImage} alt="SignLive" />
            //         </div>
            //         <div
            //             className="image-stack__item image-stack__item—bottom"
            //             style={{ position: 'fixed', top: '15rem' }}
            //         >
            //             <StyledVideoPlayerEmail>
            //                 <ZiggeoPlayer
            //                     apiKey={this.API_KEY}
            //                     video={this.VIDEO_TOKEN}
            //                     theme="modern"
            //                     height="100%"
            //                     width="100%"
            //                     themecolor="red"
            //                     skipinitial={false}
            //                     auto-pad
            //                     showsettings
            //                     fittodimensions
            //                     videofitstrategy="original"
            //                 />
            //             </StyledVideoPlayerEmail>
            //         </div>
            //     </div>
            // </UserLayout>
            <StyledVideoPlayerEmail>
                <ZiggeoPlayer
                    apiKey={this.API_KEY}
                    video={this.VIDEO_TOKEN}
                    theme="modern"
                    height="100%"
                    width="100%"
                    themecolor="red"
                    skipinitial={false}
                    auto-pad
                    showsettings
                    fittodimensions
                    videofitstrategy="original"
                />
            </StyledVideoPlayerEmail>
        );
    }
}
export default VideoPlayer;
